import { render, staticRenderFns } from "./West2School.vue?vue&type=template&id=2ddd0d9b&"
import script from "./West2School.vue?vue&type=script&lang=js&"
export * from "./West2School.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports